/**
 * StringControl — Debounced text input for string props.
 */

import { useState, useEffect, useRef } from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface StringControlProps {
  value: string
  onChange: (v: string) => void
  label: string
  placeholder?: string
  maxLength?: number
}

export function StringControl({
  value,
  onChange,
  label,
  placeholder,
  maxLength,
}: StringControlProps) {
  const [local, setLocal] = useState(value)
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  // Sync from parent when value changes externally
  useEffect(() => {
    setLocal(value)
  }, [value])

  const handleChange = (next: string) => {
    setLocal(next)
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => onChange(next), 300)
  }

  useEffect(() => {
    return () => clearTimeout(timerRef.current)
  }, [])

  return (
    <div className="space-y-1.5">
      <Label className="text-[13px] font-medium text-gray-600">{label}</Label>
      <Input
        value={local}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    </div>
  )
}
